var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "12%", height: "90%", "overflow-y": "hidden" },
      attrs: {
        width: _vm.modalWidth,
        visible: _vm.visible,
        title: _vm.title,
        cancelText: "关闭",
        wrapClassName: "ant-modal-cust-warp",
      },
      on: { ok: _vm.handleSubmit, cancel: _vm.close },
    },
    [
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c("a-col", { attrs: { md: 24, sm: 24 } }, [
            _c(
              "div",
              [
                _c(
                  "a-form",
                  {
                    attrs: { layout: "inline" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onAdd.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "a-tabs",
                      {
                        attrs: {
                          "default-active-key": "1",
                          "tab-position": "left",
                        },
                      },
                      [
                        _c(
                          "a-tab-pane",
                          {
                            key: "1",
                            attrs: { tab: "单个序列号", forceRender: "" },
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 24, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "序列号",
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          ref: "name",
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            placeholder:
                                              "请输入序列号并回车（只能输入数字或字母）",
                                            oninput:
                                              "value=value.replace(/[\\W]/g,'')",
                                          },
                                          model: {
                                            value: _vm.queryParam.name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.name",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticStyle: { float: "left" } },
                                          [
                                            _c(
                                              "a-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: { click: _vm.onAdd },
                                              },
                                              [_vm._v("添加")]
                                            ),
                                            _c(
                                              "a-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "8px",
                                                },
                                                on: { click: _vm.clearAllSn },
                                              },
                                              [_vm._v("清空")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-tab-pane",
                          {
                            key: "2",
                            attrs: { tab: "多个序列号", forceRender: "" },
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 24, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                          label: "序列号",
                                        },
                                      },
                                      [
                                        _c("a-textarea", {
                                          staticStyle: { width: "400px" },
                                          attrs: {
                                            placeholder:
                                              "多个序列号用逗号隔开，请少于2000个字符",
                                            "auto-size": {
                                              minRows: 2,
                                              maxRows: 4,
                                            },
                                          },
                                          model: {
                                            value: _vm.queryParam.multiName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "multiName",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.multiName",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticStyle: { float: "left" } },
                                          [
                                            _c(
                                              "a-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: { click: _vm.onBatchAdd },
                                              },
                                              [_vm._v("批量添加")]
                                            ),
                                            _c(
                                              "a-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "8px",
                                                },
                                                on: { click: _vm.clearAllSn },
                                              },
                                              [_vm._v("清空")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "a-row",
        { staticStyle: { padding: "10px" }, attrs: { gutter: 10 } },
        [
          _c(
            "a-col",
            { attrs: { md: 24, sm: 24 } },
            [
              _c("a-table", {
                ref: "table",
                attrs: {
                  scroll: _vm.scrollTrigger,
                  size: "middle",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.checkDataSource,
                  pagination: false,
                  loading: _vm.loading,
                },
                scopedSlots: _vm._u([
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c("span", {}, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.removeSn(record)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }